module.exports = __webpack_public_path__ + "img/Registration.3a97e3ab.svg";